export function requiresGoogleSignIn(email: string): boolean {
  const normalized = email.trim().toLowerCase();
  const atIndex = normalized.lastIndexOf('@');

  if (atIndex === -1) {
    return false;
  }

  const localPart = normalized.slice(0, atIndex);
  const domain = normalized.slice(atIndex + 1);

  if (domain !== 'chargemont.com') {
    return false;
  }

  if (localPart.includes('+')) {
    return false;
  }

  return true;
}
